import React, { Component } from 'react'
import { LinearProgress, GET_ONE } from 'react-admin'

import dataProvider from '../../utils/dataProvider'


const sufixes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

class DocumentField extends Component {
  state = {
    loading: true,
    document: null
  }

  componentDidMount() {
    const { record, source } = this.props
    this.setState({ loading: true })
    dataProvider(GET_ONE, 'documentos', { id: record[source] })
      .then(response => {
        this.setState({ loading: false, document: response.data })
      })
      .catch(e => {
        console.error(e)
        this.setState({ loading: false, document: false })
      })
  }

  getBytes = (bytes) => {
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (!bytes && '0 Bytes') || (bytes / Math.pow(1024, i)).toFixed(2) + " " + sufixes[i];
  };

  render() {
    const { loading, document } = this.state
    if (loading) {
      return <LinearProgress />
    } else if (!!document) {
      return (
        <a href={`${process.env.STORAGE_URL}/${document.file_name}`}>{document.name} ({this.getBytes(document.file_size)})</a>
      )
    } else {
      return "---"
    }

  }
}

export default DocumentField
